import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            const hasToken = !!authService.getAccessToken();

            if (hasToken && error.status === HttpStatusCode.Unauthorized) {
                authService.endSession();
            }

            return throwError(() => error);
        })
    );
};
